import type { AutocompleteProps } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Box } from "@mui/material";
import React from "react";

import { RESOURCE_STAR_HOVER_STYLES } from "../ResourceStarButton/ResourceStarButton";

type AutocompleteWithWrapProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> = AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>;

const AutocompleteWithWrap = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>(
  props: AutocompleteWithWrapProps<T, Multiple, DisableClearable, FreeSolo>,
) => {
  return (
    <Autocomplete
      {...props}
      renderOption={(optionProps, option) => {
        const { key, ...restOptionProps } = optionProps;
        return (
          <li key={key} {...restOptionProps}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: 1,
                ...RESOURCE_STAR_HOVER_STYLES,
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  minWidth: 0,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {props.getOptionLabel
                  ? props.getOptionLabel(option)
                  : (option as React.ReactNode)}
              </Box>
            </Box>
          </li>
        );
      }}
    />
  );
};

export { AutocompleteWithWrap };
